<template>
  <footer id="footer" class="module uppercase" v-if="project">
    <div class="container">
      <div class="text-center">
        <p>
          &copy; {{ project.copyright.name }} {{ currentYear }}<span class="spacer">|</span><a target="_blank" :href="project.copyright.url">{{ project.copyright.url_display_name }}</a>
        </p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  data () {
    return {
      currentYear: new Date().getFullYear()
    }
  },
  props: {
    project: {
      type: Object,
      default: null
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '@/assets/scss/_site_variables.scss';
  @import '@/assets/scss/partials/_mixins.scss';

  a {
    border-bottom: none;
    color: white;
  }
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue